<!-- Theme CSS -->
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">
<!-- introduction Section -->
<lang-change></lang-change>
<section id="introduction" class="container content-section">
    <div class="row">
        <div class="col-lg-12">
            <h2 class="heading">Admin Portal</h2>
	        	  <a class="btn-mg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" [routerLink]="['/register']" i18n>Register</a>
	        <div class="tab">
				<button class="tablinks" i18n>Functional user</button>
				<button class="tablinks" i18n>Viewer user</button>
				<button class="tablinks" i18n>Technical user</button>
				<button class="tablinks" i18n>Administrator</button>
			</div>
			<div class="tabcontent">
	            <p><b>Functional user:</b> the one who enters and manage the data in the PSS.</p>
	            <p><b>Viewer user:</b> the one only able to see the data (graphics, Summary View) and to download a PDF report. </p>
	            <p><b>Technical user:</b> the one who has knowledge of the functionality of the PSS and is the one who can modify formulas, calculations, presentation format of the tool, and include new questions.</p>
	            <p><b>Administrator:</b> the one who is granted access to all data and has rights to create, update, and configure the system.</p>
			</div>
        </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.html